import {useEffect, useRef} from 'react';

import {useDocumentContext} from '@/components/document/context';
import {useDocumentStore} from '@/components/document/store';
import {DocumentInputField, DocumentValue} from '@/engine';
import {isChoiceField} from '@/utils/document/field';

export const useSetFieldInitialValue = (field: DocumentInputField, value: DocumentValue | DocumentValue[]) => {
  const updateField = useDocumentStore(({updateField}) => updateField);
  const {ready, valueResolver, visibilitySet} = useDocumentContext();
  const triggered = useRef(false);

  useEffect(() => {
    if (!ready || triggered.current) return;

    if (field.initialValue) {
      // Prevent initial value from triggering twice
      triggered.current = true;
    }

    if (!value && field.initialValue) {
      const initialValue = isChoiceField(field)
        ? field.initialValue
        : valueResolver(field.initialValue, {keepDomainReference: true, visibilitySet});
      updateField(field.id, initialValue);
    }
  }, [updateField, field, value, valueResolver, visibilitySet, triggered, ready]);
};
